export const signUpUsernameCookieKey = 'username';
export const signUpEmailCookieKey = 'email';
